import { Helmet } from "react-helmet-async";

function Home() {
  return (
    <div className="min-h-[calc(100vh-160px)] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 flex flex-col items-center justify-center px-6 text-center">
      <Helmet>
        <title>Luis Torre</title>
        <meta name="description" content="Learn more about Luis Torre, a Computer Engineering graduate working in automation." />
      </Helmet>
      
      <h1 className="text-6xl sm:text-7xl font-extrabold text-white mb-4 relative inline-block">
        Luis Torre
        {/* Gradient underline */}
        <span className="absolute left-0 bottom-0 w-full h-1 bg-[#45577a] rounded-full"></span>
      </h1>

      <p className="text-gray-300 text-xl sm:text-2xl mt-6">
        Computer Engineer | Automation Fan
      </p>

      {/* Optional separator for a nice touch */}
      <div className="mt-8 w-32 h-1 bg-[#45577a] rounded-full"></div>
    </div>
  );
}

export default Home;
